// Projects
import App from './components/App.svelte';

// Prevent Google Maps from loading Roboto font
//
var head = document.getElementsByTagName('head')[0];

// Save the original method
var insertBefore = head.insertBefore;

// Replace it!
head.insertBefore = function (newElement, referenceElement) {

    if (newElement.href && newElement.href.indexOf('//fonts.googleapis.com/css?family=Roboto') > -1) {

        console.info('Prevented Roboto from loading!');
        return;
    }

    insertBefore.call(head, newElement, referenceElement);
};

const appTarget = document.querySelector('.project-listing');

if (appTarget) {
  appTarget.innerHTML = '';

  var app = new App({
    target: appTarget,
    props: {
      ...window.__DATA__,
      ...window.__PROJECTS__
    }
  });
}

export default app;
